/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal, Leonid Khramov
 */
import { connect } from 'react-redux'
import React from 'react'
import { withRouter } from 'react-router'

import * as act from '../actions/teams'
import * as staff from '../actions/staff'

import './TeamEditContainer.css'
import TeamEditor from '../components/TeamEditor'
import {TeamEdit} from './TeamEditContainer'
import { TRCButton, TRCInput } from '../../../trace'
import { pageTitle } from 'trux'
import { formatShortName, formatFullName } from '../../../trace/formatters'

class AddTeam extends TeamEdit {

    constructor(props) {
        super(props)

        this.state['add_roles'] = {}

        this.onEditorUpdate = this.onEditorUpdate.bind(this)
        this.doSaveChanges = this.doSaveChanges.bind(this)
        this.onRoleChanged = this.onRoleChanged.bind(this)
    }

    componentDidMount() {
        pageTitle(this.props.title, "Settings - Add Team")
    }

    getRolesList() {
        let roles = []

        for(let member of this.props.members) {
            let m = Object.assign({}, member)
            console.log('m', m)
            m.is_coach = this.state.add_roles[m.user_id] === 'coach'
            m.is_videographer = this.state.add_roles[m.user_id] === 'manager'
            roles.push(m)
        }
        return roles
    }

    onRoleChanged(userId, role) {
        console.log('onRoleChanged', userId, role)
        let roles = Object.assign({}, this.state.add_roles)
        roles[userId] = role
        this.setState({ add_roles: roles })
    }

    renderContent() {
        const members_with_roles = this.getRolesList()

        return (
            <div className="TeamPage modal-container content">
                <form id="add_team" onSubmit={this.onSaveAll}>

                    <TeamEditor
                        team={this.props.team}
                        members={members_with_roles}
                        onChange={this.onEditorUpdate}
                        onMemberRoleChanged={this.onRoleChanged}
                        errors={this.state.errors}
                    />

                    <div className="trc-grid bottom-buttons">
                        <div className="col ml-f6 m-ff12 pb">
                            <TRCInput
                                type="submit"
                                disabled={ this.state.saveDisabled }
                                full
                                value={ this.state.saveDisabled ? 'Saving ...' : 'Save' }
                            />
                        </div>
                        <div className="col ml-f6 m-ff12">
                            <TRCButton
                                secondary
                                full
                                onClick={ this.onBackToTeam }>
                                Cancel
                            </TRCButton>
                        </div>
                    </div>

                </form>
            </div>
        )
    }

    isFromIOS() {
        return this.props.via === 'iosapp'
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.divisionId !== this.props.divisionId) {
            this.props.history.replace(`/${this.props.match.params.team}/division/${nextProps.divisionId}/teams`)
        }

        const users = nextProps.users
        let roles = []
        for(let user of users) {
            const fullname = user.full_name
            const link = `/division/${nextProps.divisionId}/staff/${user.user_id}/edit`
            let role = { id: user.user_id, title: fullname, stitle: this.shortenName(fullname), role: null, link: link, user: user}
            roles.push(role)
        }
        this.setState({initialRoles: roles})
    }

    doSaveChanges() {
        if(this.state.errors.length > 0) return

        var editState = Object.assign({}, this.state.editorState)
        if (editState.title) {
            editState.title = editState.title.trim()
        }
        if (editState.abbr) {
            editState.abbr = editState.abbr.trim()
        }
        if (editState.players_birth_year) {
            editState.players_birth_year = parseInt(editState.players_birth_year, 10)
        }

        const roles = this.getRolesList()
        let update = []
        for (let role of roles) {
            if (role.is_coach || role.is_videographer) {
                update.push({
                    team_id: this.props.teamId,
                    user_id: role.user_id,
                    is_player: false,
                    is_coach: role.is_coach,
                    is_videographer: role.is_videographer,
                    team_player_id: null
                })
            }
        }

        if(this.props.addTeam) {
            const self = this
            this.setState({saveDisabled: true})
            this.props.addTeam(editState, this.props.divisionId, update, () => {
                self.props.history.goBack()
            })
        }
    }
}

const mapStateToProps = (state, props) => {
    let teams = []
    const divisionId = props.match.params.division_id
    const teamId = -1
    const team = {}
    const teamUsers = []
    let divisions = []
    const users = state.division_staff.value.staff.sort((a,b) => {
        let an = `${a.first_name} ${a.last_name}`
        let bn = `${b.first_name} ${b.last_name}`
        return an.localeCompare(bn)
    })
    let members = []
    
    // divisions
    if (state.divisions.value) {
        divisions = state.divisions.value.filter(d => d.division_id > 0)
    }

    // teams
    for (let div of divisions) {
        if (div.division_id === divisionId) {
            teams = div.myTeams
        }
    }

    // Load members
    if (state.division_staff.complete) {
        for (let dm of state.division_staff.value.staff) {
            let member = Object.assign({}, dm)
            member.team_player_id = 0
            member.team_id = 0
            member.is_active = true
            member.is_player = false
            member.is_videographer = false
            member.is_coach = false
            member.user = dm.user
            member.loading = dm.loading
            member.error = dm.error

            member.id = 'team-role-editor-memeber'+dm.user_id
            member.short_name = formatShortName(dm)
            member.full_name = formatFullName(dm)
            member.link = null
            members.push(member)
        }
    }

    return {
        via: state.via,
        teams,
        divisionId,
        teamId,
        team,
        users,
        teamUsers,
        members,
        title: 'Add Team',
        addTeam: true,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        loadTeams: (divisionId) => {
            dispatch(act.loadTeamsByDivision(divisionId))
        },
        changeTeam: (data) => {
        },
        loadMembers: (divisionId) => {
            dispatch(staff.loadStaffByDivision(divisionId))
        },
        loadTeamMembers: (teamId) => {
            dispatch(act.loadTeamUsersById(teamId))
        },
        addTeam: (data, divisionId, roles, callback) => {
            dispatch(act.addTeamWithDivision(data, divisionId, roles, callback))
        }
    }
}

const AddTeamContainer = withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(AddTeam))

export default AddTeamContainer
